






















import { defineComponent, PropType } from '@vue/composition-api';
import { Collection } from '@oare/types';
import { letterGroups } from './utils';

export default defineComponent({
  name: 'CollectionsList',
  props: {
    collections: {
      type: Array as PropType<Collection[]>,
      required: true,
    },
  },
  setup() {
    return {
      letterGroups,
      encodedLetter: (letter: string) => encodeURIComponent(letter),
    };
  },
});
